import { TypographyParagraph, TypographyLabel } from '../../typography'
import TypographyHeader from '../../typography/TypographyHeading'
import { CalendarIcon, LinkIcon, FullScreenIcon } from '../../icons'
import { formatDateToLongFormat } from '#app/utils/timeUtils'
import InternalLink from '#app/components/common/internalLink.tsx'
import Button from '../../buttons/button'
import Image from '#app/components/common/image.tsx'
import { Modal } from '../../modalsAndOverlays'
import { useState } from 'react'

type FarcastProps = {
  metadata: {
		createdAt?: Date;
    properties: {
      url?: string;
      ipfsCID?: string;
      web2URL?: string;
    };
  };
}

export default function Farcast({ metadata }: FarcastProps) {
  const { properties } = metadata;
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);

  return (
    <div className="flex flex-col space-y-2">
      {/* Date with Icon */}
      {metadata.createdAt && (
        <div className="flex items-center space-x-2 text-textSecondaryLight dark:text-textSecondaryDark">
          <CalendarIcon size="small" />
          <TypographyLabel size="small">
            {formatDateToLongFormat(metadata.createdAt || '')}
          </TypographyLabel>
        </div>
      )}

      {/* Web2 URL Image */}
      {(properties.web2URL || properties.ipfsCID) && (
        <div 
          className="rounded-lg overflow-hidden cursor-pointer transition-all duration-200 relative group"
          onClick={() => setIsImageModalOpen(true)}
        >
          <Image
            imageUrl={properties.web2URL ? properties.web2URL : properties.ipfsCID} 
            imageAlt="Cast preview"
            containerClassName="rounded-lg overflow-hidden bg-uiPrimaryLight dark:bg-uiTertiaryDark hover:brightness-50"
            className="w-full h-[180px] object-contain"
          />
          <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-200">
            <div className="absolute inset-0 bg-black/30"></div>
            <FullScreenIcon size="large" className="text-white relative z-10" />
          </div>
        </div>
      )}

      {/* View Original Cast Link */}
      {properties.url && (
        <a target="_blank" rel="noreferrer" href={properties.url} className='flex flex-row space-x-1'>
          <Button variant="tertiary" size="xSmall" additionalClasses="flex flex-row space-x-0" leftIcon={<LinkIcon size="small" />}>
            View Original Cast
          </Button>
        </a>
      )}

      {/* Image Modal */}
      <Modal
        size="xLarge"
        isOpen={isImageModalOpen}
        onClose={() => setIsImageModalOpen(false)}
        body={
          <div className="flex justify-center items-center">
            <Image
              imageUrl={properties.web2URL ? properties.web2URL : properties.ipfsCID} 
              imageAlt="Cast preview"
              containerClassName="rounded-lg overflow-hidden bg-uiPrimaryLight dark:bg-uiTertiaryDark"
              className="w-full h-auto object-contain"
            />
          </div>
        }
      />
    </div>
  );
} 